import { getMarkRange } from "@tiptap/core";
import { type EditorState, NodeSelection, TextSelection } from "@tiptap/pm/state";

export type ToolbarContext =
	| { kind: "node"; pos: number; parentPos?: number }
	| { kind: "container"; pos: number }
	| { kind: "file"; from: number; to: number; resourcePath: string }
	| { kind: "text" };

const containers = new Set(["note", "code_block", "question"]);

const nodeGroups = new Set(["gallery"]);

const nodes = new Set([
	"image",
	"inlineImage",
	"diagrams",
	"drawio",
	"video",
	"gallery",
	"html",
	"openapi",

	"view",
	"fragment",
	...containers,
]);

export const resolveToolbarContext = ({ selection, schema, doc }: EditorState): ToolbarContext => {
	if (selection instanceof NodeSelection && nodes.has(selection.node.type.name)) {
		const { $from } = selection;
		if ($from.depth > 0 && nodeGroups.has($from.parent.type.name))
			return { kind: "node", pos: selection.from, parentPos: $from.before() };
		return { kind: "node", pos: selection.from };
	}

	if (selection instanceof TextSelection && schema.marks.file) {
		const range = getMarkRange(selection.$from, schema.marks.file);
		if (range && selection.to <= range.to) {
			const mark = schema.marks.file.isInSet(doc.nodeAt(range.from)?.marks ?? []);
			if (mark?.attrs.resourcePath) return { kind: "file", ...range, resourcePath: mark.attrs.resourcePath };
		}
	}

	if (selection instanceof TextSelection && selection.empty) {
		for (let depth = selection.$from.depth; depth > 0; depth--) {
			if (containers.has(selection.$from.node(depth).type.name)) {
				return { kind: "container", pos: selection.$from.before(depth) };
			}
		}
	}

	return { kind: "text" };
};
